import axios from 'axios';
import msg from '../../messages';
import store from '../store';

export class ConversionApiTracker {
    serviceName = 'capi';
    #eventData;

    constructor(eventData) {
        this.#eventData = eventData;
    }

    firePixelEvent(eventName) {
        const eventDataConfig = this.#eventDataConfig();

        if (!eventDataConfig.hasOwnProperty(eventName)) {
            return;
        }

        eventDataConfig[eventName]();
    }

    firePurchaseEvent(price, orderID, currency) {
        // pass
    }

    fireCheckoutStartedEvent() {
        // pass
    }

    fireAddPaymentInfoEvent(paymentType) {
        // pass
    }

    #eventDataConfig() {
        return {
            first_buy_buttons_are_seen: () => {
                this.#conversionApi('ViewContent');
            },
            checkout_buy_button_is_clicked: () => {
                this.#conversionApi('InitiateCheckout');
            },
        };
    }

    #conversionApi(event) {
        try {
            const paramString = store.state.originalUrl.split('?')[1];
            axios
                .post(
                    '/api/conversion-api?' + paramString,
                    Object.assign(
                        {
                            event,
                            progress_tracking_slug: store.getters.product.progress_tracking_slug,
                        },
                        store.getters.formData,
                    ),
                )
                .catch((err) => {});
        } catch (err) {
            logger.captureException(new Error(msg.tracking.capiCallFailed), { extra: err });
        }
    }
}
